import '../style.css';
import './game.css';
import { mountFateMarble } from './game';

mountFateMarble();
